import React, { Component } from 'react';
import axios from 'axios';

import Free from './free';
import Premium from './premium';
import Loading from '../../components/Loading';
import Header from '../../components/Header/Header';
import NoLocationPlaceHolder from '../../components/NoLocationPlaceholder/NoLocationPlaceholder';

import { ANALYTICS_URL, 
         RESTAURANT_ID_URL,
} from '../../config';


const performAudit = require('./audit').performAudit;
const parseOutput = require('./analyticsParser').parseOutput;

const CLICK = 0, DIET = 1, ALLERGEN = 2;
const MAX_RETRIES = 5;
class Analytics extends Component {
  constructor(props){
    super(props);
    if(!this.props.client){
      this.props.updateClient();
    }

    this.state = {
      clicks : null,
      allergens : null,
      diets : null,
      audit: null,
    }
    this.retries = 0;
  }

  /**
   * Fetch audit data for the current restaurant
   */
  fetchAudit(){
    if(this.props.client && this.props.client.locations.length > 0){
      let id = this.props.client.locations[this.props.activeLocation]["_id"];
      let requestUrl = RESTAURANT_ID_URL(id);
      let self = this;

      axios.get(
        requestUrl,
        {
          headers: {
            "Authorization": this.props.client.token,
            "Content-Type": "application/json"
          }
        }
      ).then(function(response){
        self.setState({audit: performAudit(response.data.items)});
      }).catch(function(err){
      })

    }
  }

  
  /**
   * Fetch analytics data for a specific type of report (clicks, diets, allergens)
   * @param {int} type : type of analytics request. Defined in config.js
   */
  fetchAnalytics(){
    if(this.props.client && this.props.client.locations && this.props.client.locations.length > 0){
      if(this.retries >= MAX_RETRIES) return;
      let id = this.props.client.locations[this.props.activeLocation]["id"];
      let requestUrl = ANALYTICS_URL(id);      
      let self = this;

      axios.get(
        requestUrl,
        {
          headers: {
            "Authorization": this.props.client.token,
            "Content-Type": "application/json"
          }
        }
      ).then(function(response){
            if(response.data) {
              self.retries = MAX_RETRIES;
              let analyticsData = parseOutput(response.data);
              self.setState({
                clicks: analyticsData.clicks, 
                diets: analyticsData.diets,
                allergens: analyticsData.allergens
              });
            }
            else {
              self.retries++;
            }

      }).catch(function(err){
          self.retries++;
      })
    }
  }

  /**
   * Renders placeholder component if user has not added a location yet
   */
  get noLocation(){
    return(
      <div>
        {this.header}
        <div className="pageContainer">
          <NoLocationPlaceHolder/>
        </div>
      </div>
    )
  }

  get header(){
    return(
      <Header
        pageName="ANALYTICS"
      />
    )
  }


  render() {
    if(!this.props.client) return null;

    if(!this.props.client.locations || this.props.client.locations.length == 0) 
      return (this.noLocation);

    if(this.state.clicks == null) this.fetchAnalytics();
    if(this.state.audit == null) this.fetchAudit();

    if(this.state.clicks == null || this.state.diets == null 
        || this.state.allergens == null) 
        return (<div>{this.header}<div className="loading-container"><Loading/></div></div>);

    if(!this.props.client.plan)
      return (
        <div>
          {this.header}
          <div className="pageContainer">
            <Free 
              clicks = {this.state.clicks}
              diets  = {this.state.diets}
              allergens = {this.state.allergens}
              audit = {this.state.audit}
              client = {this.props.client}
              activeLocation = {this.props.activeLocation}
              updateActiveLocation = {this.props.updateActiveLocation}
            />
          </div>
        </div>
      );
    return (
      <div>
          {this.header}
        <div className="pageContainer">
          <Premium
            clicks = {this.state.clicks}
            diets  = {this.state.diets}
            allergens = {this.state.allergens}
            audit = {this.state.audit}
            client = {this.props.client}
            activeLocation = {this.props.activeLocation}
            updateActiveLocation = {this.props.updateActiveLocation}
          />
        </div>
      </div>
    ) ;
  }
}

export default Analytics;



// WEBPACK FOOTER //
// ./src/views/Analytics/Analytics.js